import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Flex, Stack, TextInput, Textarea } from "@mantine/core";
import { useForm, yupResolver } from "@mantine/form";
import { AppModal } from "../../shared/AppModal";
import { useEffect } from "react";
import { useCreateSimpleEmailTemplateMutation, useGetSimpleEmailTemplateQuery, useUpdateSimpleEmailTemplateMutation } from "../../graphql/graphql";
import { showErrorNotification, showSuccessNotification } from "../../shared/Notifications";
import { SimpleEmailTemplateInitialValues, SimpleEmailTemplateSchema } from "./SimpleEmailTemplate.validation";
export const SimpleEmailTemplateModal = ({ opened, close, refetchSimpleEmailTemplates, simpleEmailTemplateId }) => {
    const [{ data, fetching }] = useGetSimpleEmailTemplateQuery({
        pause: !opened || !simpleEmailTemplateId,
        variables: {
            simpleEmailTemplateId: simpleEmailTemplateId ?? ""
        },
        requestPolicy: "network-only"
    });
    const [{ fetching: createFetching }, createSimpleEmailTemplate] = useCreateSimpleEmailTemplateMutation();
    const [{ fetching: updateFetching }, updateSimpleEmailTemplate] = useUpdateSimpleEmailTemplateMutation();
    const form = useForm({
        mode: "controlled",
        initialValues: SimpleEmailTemplateInitialValues,
        validate: yupResolver(SimpleEmailTemplateSchema)
    });
    useEffect(() => {
        if (!opened)
            return;
        if (simpleEmailTemplateId) {
            const template = data?.simpleEmailTemplates?.simpleEmailTemplate;
            if (template) {
                form.setValues({
                    subject: template.subject ?? "",
                    body: template.body ?? ""
                });
            }
        }
        else {
            form.setValues(SimpleEmailTemplateInitialValues);
        }
        form.resetDirty();
    }, [
        opened,
        simpleEmailTemplateId,
        data?.simpleEmailTemplates?.simpleEmailTemplate
    ]);
    const handleClose = () => {
        close();
        form.reset();
    };
    const handleSubmit = async (event) => {
        event.preventDefault();
        const valid = form.validate();
        if (valid.hasErrors)
            return;
        try {
            if (simpleEmailTemplateId) {
                await updateSimpleEmailTemplate({
                    simpleEmailTemplateId,
                    subject: form.values.subject,
                    body: form.values.body
                });
                showSuccessNotification("Email template updated successfully.");
            }
            else {
                await createSimpleEmailTemplate({
                    subject: form.values.subject,
                    body: form.values.body
                });
                showSuccessNotification("Email template created successfully.");
            }
            refetchSimpleEmailTemplates();
            handleClose();
        }
        catch (error) {
            console.error(error);
            showErrorNotification();
        }
    };
    return (_jsxs(AppModal, { title: `${simpleEmailTemplateId ? "Edit" : "Create"} Email Template`, opened: opened, onClose: handleClose, size: "lg", children: [_jsxs(Stack, { children: [_jsx(TextInput, { "data-autofocus": true, required: true, label: "Subject", placeholder: "Subject", ...form.getInputProps("subject") }), _jsx(Textarea, { required: true, label: "Body", placeholder: "Write your email body here...", autosize: true, minRows: 10, maxRows: 18, styles: { input: { whiteSpace: "pre-wrap" } }, ...form.getInputProps("body") })] }), _jsxs(Flex, { justify: "flex-end", mt: "lg", gap: "sm", children: [_jsx(Button, { variant: "outline", color: "gray", onClick: handleClose, children: "Cancel" }), _jsx(Button, { variant: "filled", loading: fetching || createFetching || updateFetching, onClick: handleSubmit, children: simpleEmailTemplateId ? "Update" : "Create" })] })] }));
};
